import { CheckCheck, Loader2 } from 'lucide-react';
import type { PendingCASummary } from './pendingCa.types';

interface Props {
  summary: PendingCASummary | null;
  onBulkHighConfidence: () => void;
  bulkBusy?: boolean;
}

// 권위: ARCH_DASHBOARD §4.10 상단 요약 배너.
export function PendingCASummaryBanner({
  summary,
  onBulkHighConfidence,
  bulkBusy,
}: Props): JSX.Element {
  const pending = summary?.pendingCount ?? 0;
  const autoAccepted = summary?.autoAcceptedCount ?? 0;
  const todayNew = summary?.todayNewCount ?? 0;

  return (
    <div className="pca-banner">
      <Metric label="미검수 건수" value={pending} highlight={pending > 0} />
      <Metric label="자동 처리 건수" value={autoAccepted} />
      <Metric label="오늘 신규" value={todayNew} />
      <div className="pca-banner__action">
        <button
          type="button"
          className="pca-btn pca-btn--primary"
          onClick={onBulkHighConfidence}
          disabled={bulkBusy || pending === 0}
          title="confidence ≥ 0.90 건을 일괄 승인합니다."
        >
          {bulkBusy ? (
            <Loader2 size={14} strokeWidth={1.75} className="pca-spin" />
          ) : (
            <CheckCheck size={14} strokeWidth={1.75} />
          )}
          {bulkBusy ? '처리 중…' : '일괄 승인 (conf ≥ 0.90)'}
        </button>
      </div>
    </div>
  );
}

function Metric({
  label,
  value,
  highlight,
}: {
  label: string;
  value: number;
  highlight?: boolean;
}): JSX.Element {
  return (
    <div className="pca-banner__metric">
      <div className="pca-banner__label">{label}</div>
      <div
        className="pca-banner__value"
        style={highlight ? { color: 'var(--warn)' } : undefined}
      >
        {value.toLocaleString('ko-KR')}
      </div>
    </div>
  );
}
